<template>
  <div class="wrap">
    <div class="wrap-box  theme-color">
      <!-- <el-form ref="form" :model="form" size="small" class="carForm">
        <el-form-item label="关键字" class="form-item">
          <el-input v-model="pageName" placeholder="请输入关键字" class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="系统列表：" class="form-item">
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in subsystems"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
      <!-- <el-form-item label="页面路径"  class="form-item">
                    <el-input v-model="pagePath" placeholder="请输入内容" class="form-input"></el-input>
                </el-form-item> -->
      <!-- <el-button size="small" type="primary" class="form-buttom" @click="getData(1)">查询</el-button>
        <el-button size="small" type="primary" class="form-buttom" :disabled="$center" @click="addPage()">添加页面</el-button>
      </el-form> -->
      <div class="revenue-header">
        <div class="seach-box">
          <span class="time">时间</span>
          <div>
            <el-date-picker
              v-model="seachData.startTime"
              type="date"
              value-format="yyyy/MM/dd"
              placeholder="开始日期"
              :picker-options="pickerOptions6"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="seachData.endTime"
              type="date"
              value-format="yyyy/MM/dd"
              placeholder="结束日期"
              :picker-options="pickerOptions7"
            >
            </el-date-picker>
          </div>
          <span style="margin-left:10px;margin-right:10px">类型</span>
          <div class="select">
            <el-select v-model="seachData.type" placeholder="请选择">
              <el-option
                v-for="item in quarterList.proprietor"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <el-button @click="seachTable" type="primary" style="margin-left:10px"
            >查询</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        style="margin-top:15px;"
        height="620"
        empty-text="该表格暂无页面数据"
        border
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          label="合同编号"
          prop="contractId"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="creatingTime"
          label="生成日期"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="propertyCompanyName"
          label="所属物业"
          align="center"
        ></el-table-column>

        <el-table-column label="账单日期" align="center">
          <template slot-scope="scope">
            {{ scope.row.startTime }}至{{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="缴费金额"
          align="center"
        ></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            {{ stateType[scope.row.status] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              @click="showPage(scope.row)"
              type="text"
              size="small"
              :disabled="$center"
              >明细</el-button
            >
            <el-button
              v-if="scope.row.status == 0"
              @click="showPayment(scope.row)"
              type="text"
              size="small"
              :disabled="$center"
              >支付</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 新增弹窗 -->
     <el-dialog
        title="明细"
        :visible.sync="pageDig"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="1000px"
      >
        <div class="dialogbox" v-if="detailData">
          <div class="box">
            <p>账单详情</p>
            <div class="flexbox">
              <div><span>总金额：</span> ￥{{ detailData.totalAmount }}</div>
              <div><span>支付状态：</span>{{ stateType[detailData.status] }}</div>
              <div><span>支付时间：</span>{{ detailData.payingTime||'空' }}</div>
              <div><span>支付方式：</span>{{ paymentType[detailData.paymentMode]||'空' }}</div>
            </div>
            <div class="flexbox">
              <div><span>业主公司：</span>{{ detailData.proprietorCompanyName||'空' }}</div>
              <div><span>物业公司：</span>{{ detailData.propertyCompanyName ||'空'}}</div>
              <div>
                <span>结算时间：</span>
                {{ detailData.startTime }}至{{ detailData.endTime }}
              </div>
              <div><span>生成时间：</span>{{ detailData.creatingTime||'空' }}</div>
            </div>
          </div>
          <div class="box">
            <p>费用明细</p>

            <div class="sonbox" v-if="detailData">
              <p>计费规则</p>

              <div
                class="flexbox"
                v-for="(item, i) in detailData.detailsOfCharges.energyPricing
                  .pricingRegulation"
                :key="i"
              >
                <div><span>计费模型：</span>{{ item.model }}</div>
                <div><span>能源类别：</span>{{ eleType[item.type] }}</div>
                <div style="display:flex;">
                  <span>计费规则：</span>
                  <p style="margin-right:10px;" v-for="(item1, i) in item.items" :key="i"
                    >{{ item1.hint }} {{ item1.unitPrice }}元</p
                  >
                </div>
              </div>
              <!-- <div class="flexbox">
                <div>能源类别：水</div>
                <div>>=0立方米 单价:2元/立方米</div>
                <div>>=50立方米 单价:2元/立方米</div>
              </div>
              <div class="flexbox">
                <div>能源类别： 天然气</div>
                <div>巅峰单价： 1.50元/kWh</div>
                <div>平期单价： 1.50元/kWh</div>
                <div>谷峰单价： 单价 1.50元/kWh</div>
                <div>尖期单价： 单价 1.50元/kWh</div>
              </div> -->
            </div>
            <div class="sonbox">
              <p>基本费用表</p>
              <div
                class="flexbox"
                v-for="(item, i) in detailData.detailsOfCharges.basicCharges"
                :key="i"
              >
                <div><span>{{ item.name }}：</span>{{ item.amount }}元</div>
              </div>

              <div
                v-for="(item, i) in detailData.detailsOfCharges.energyPricing
                  .amounts"
                :key="i"
              >
                <div>场地列表</div>
                <div class="flexbox">
                  <div><span>场地名称：</span> {{ item.areaName }}</div>
                  <div><span>场地面积：</span> {{ item.areaPlace }}</div>
                </div>
                <template v-for="(item, i) in item.energy">
                  <div class="sonbox-box" :key="i">
                    <p>基本计量</p>
                    <el-table
                      :data="item.measuringBasic"
                      style="margin-top:15px;"
                      height="220"
                      empty-text="该表格暂无页面数据"
                      border
                      :header-cell-style="tableHeaderColor"
                    >
                      <el-table-column
                        label="测量点名称"
                        prop="measureName"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="测量项名称"
                        prop="expressionName"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="开始时间"
                        prop="startTime"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="结束时间"
                        prop="endTime"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="开始表码"
                        prop="startMeasuringValue"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="结束表码"
                        prop="endMeasuringValue"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="用量"
                        prop="quantity"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <div>
                            {{ eachList(scope.row.amounts, "energyCost") }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="金额"
                        prop="quantity"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <div>{{ eachList(scope.row.amounts, "amount") }}</div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="sonbox-box" :key="i">
                    <p>公共用能分摊</p>
                    <el-table
                      :data="item.measuringDistribution"
                      style="margin-top:15px;"
                      height="220"
                      empty-text="该表格暂无页面数据"
                      border
                      :header-cell-style="tableHeaderColor"
                    >
                      <el-table-column
                        label="测量点名称"
                        prop="measureName"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="测量项名称"
                        prop="expressionName"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="开始时间"
                        prop="startTime"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="结束时间"
                        prop="endTime"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="开始表码"
                        prop="startMeasuringValue"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="结束表码"
                        prop="endMeasuringValue"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="分摊比率"
                        prop="distributionRatio"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="用量"
                        prop="distributedAmounts"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <div>
                            {{
                              eachList(
                                scope.row.distributedAmounts,
                                "energyCost"
                              )
                            }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="金额"
                        prop="distributedAmounts"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <div>
                            {{
                              eachList(scope.row.distributedAmounts, "amount")
                            }}
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 支付 -->
      <el-dialog
        title="请选择支付方式"
        :visible.sync="dialogPayment"
        width="30%"
      >
        <el-select v-model="paymentBillData.type" placeholder="请选择">
          <el-option
            label="现金"
            value="2"
            v-if="[1, 3, 5, 51].indexOf(seachData.type) != -1"
          ></el-option>
          <el-option label="钱包" value="1" v-else></el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogPayment = false">取 消</el-button>
          <el-button type="primary" @click="handlePayment">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 生成引用链接 -->
      <el-dialog
        title="生成引用链接"
        :visible.sync="isShow"
        :close-on-click-modal="false"
        width="400px"
      >
        <el-form ref="form" label-width="90px" class="cldCarForm">
          <el-form-item label="链接" class="form-item">
            <span class="ztWrap">{{ urlBase }}</span>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="copy(urlBase)" class="updatabuttom"
          >复制</el-button
        >
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as utils from "@/utils/index.js";
import indexParmas from "./index";
export default {
  data() {
    return {
      row: [],
      dialogPayment: false,
      paymentBillData: {
        billId: "",
        paymentMode: "",
        type: "1"
      },
      pickerOptions6: {
        disabledDate: time => {
          if (this.seachData.endTime != "") {
            return time.getTime() > new Date(this.seachData.endTime).getTime();
          }
        }
      },
      pickerOptions7: {
        disabledDate: time => {
          // - 1 * 24 * 60 * 60 * 1000//减去一天的时间代表可以选择同一天;
          return time.getTime() < new Date(this.seachData.startTime).getTime();
        }
      },
      stateType: { 1: "已支付", 0: "未支付" },

      seachData: {
        startTime: "",
        endTime: "",
        type: 1
      },
      eleType: {
        1: "电",
        2: "水",
        3: "天然气",
        4: "柴油"
      },
      seachCondition: {
        date: new Date()
      },
      type: "",
      quarterList: indexParmas.billType,
      pageName: "",
      pagePath: "", //页面路径
      tableData: [],
      pageDig: false,
      //分页栏
      page: {
        pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
        size: 10,
        pageIndex: 1,
        total: 0
      },
      paymentType: { "1": "钱包", "2": "现金" },
      layout: "total,  prev, pager, next,sizes",
      title: "新增",
      form: {
        pageName: "",
        pagePath: "",
        loginPsd: ""
      },
      detailData: "",
      rules: {
        pageName: [
          {
            required: true,
            message: "页面名称不能为空",
            trigger: ["blur", "change"]
          }
        ],
        pagePath: [
          {
            required: true,
            message: "页面路径不能为空",
            trigger: ["blur", "change"]
          }
        ],
        loginPsd: [
          {
            required: true,
            message: "登录密码不能为空",
            trigger: ["blur", "change"]
          }
        ]
      },
      isShow: false,
      urlBase: "",
      oldTable: [],
      ifAdd: false,
      subsystems: []
    };
  },
  created() {
    this.seachData.startTime = indexParmas.getLastMonth().startDate;
    this.seachData.endTime = indexParmas.getLastMonth().endDate;
    console.log(indexParmas.getLastMonth());
    this.getData(1);
  },
  mounted() {},
  watch: {},
  methods: {
    eachList(arr, key) {
      let total = 0;
      arr.forEach(item => {
        total += item[key];
      });
      return total;
    },
    showPayment(row) {
      console.log(row);
      if ([1, 3, 5, 51].indexOf(this.seachData.type) != -1) {
        this.paymentBillData.type = "2";
      } else {
        this.paymentBillData.type = "1";
      }
      this.row = row;
      this.paymentBillData.billId = row.id;
      this.dialogPayment = true;
    },
    handlePayment() {
      indexParmas
        .paymentBill(
          this.paymentBillData.billId,
          this.paymentBillData.type,
          this.seachData.type
        )
        .then(res => {
          if (res.success) {
            this.$message.success("成功");
            this.row.status = 1;
            this.dialogPayment = false;
          }
        });
    },
    handleGetSubsystemList() {
      this.$api.subsystem.getSubsystems().then(res => {
        console.log(res);
      });
    },
    seachTable() {
      this.getData();
    },
    //查询页面
    getData(type) {
      let vm = this;
      indexParmas
        .getBillData(
          vm.seachData.startTime,
          vm.seachData.endTime,
          vm.seachData.type
        )
        .then(res => {
          if (res.success) {
            vm.tableData = res.data;
          }
          console.log(res);
        });
    },
    //改变页面大小处理
    handleSizeChange(val) {
      this.page.size = val;
      this.getData(1);
    },
    //上下一页
    handleCurrentChange(val) {
      this.getData(val);
    },
    //添加页面
    addPage() {
      let vm = this;
      vm.title = "新增";
      vm.form.pageName = "";
      vm.form.pagePath = "";
      vm.form.loginPsd = "";
      vm.pageDig = true;
    },
    //删除
    showPage(obj) {
      let vm = this;
      vm.pageDig = true;
      vm.detailData = obj;
      if (!(vm.detailData.detailsOfCharges instanceof Object)) {
        vm.detailData.detailsOfCharges = JSON.parse(
          vm.detailData.detailsOfCharges
        );
      }
      console.log(vm.detailData.detailsOfCharges);
    },
    //修改页面权限 pageId页面Id  //暂时用不到
    modifyRolePrivilegeForPage(pageId) {
      let vm = this;
      let roleId = vm.$store.state.user.info.roleId;
      vm.$api.role
        .modifyRolePrivilegeForPage(roleId, pageId, vm.form.loginPsd)
        .then(res => {
          if (res.success) {
            vm.pageDig = false;
            vm.$message({
              message: res.errorStr,
              type: "success"
            });
            vm.ifAdd = false;
            vm.from.loginPsd = "";
          } else {
            vm.$message.error(res.data.msg);
            vm.ifAdd = false;
          }
        })
        .catch(error => {});
    },
    save() {
      let vm = this;
      vm.$refs["form"].validate(valid => {
        if (valid) {
          vm.$api.page
            .addFrontEndPage(vm.form.pageName, vm.form.pagePath)
            .then(res => {
              if (res.success) {
                vm.$message({
                  message: res.errorStr,
                  type: "success"
                });
                vm.pageDig = false;
                vm.getData(1);
              } else {
                vm.$message.error(res.errorStr);
              }
            })
            .catch(error => {});
        } else {
          return false;
        }
      });
    },
    //复制
    copy(url) {
      let vm = this;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.remove();
      vm.$message({
        message: "复制成功",
        type: "success"
      });
      vm.isShow = false;
    },
    //弹窗关闭时
    formClose() {
      console.log(11111111111);
      this.$refs["form"].resetFields();
    },
    //改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #F3F3F3;color: #666;";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  color: #000000;
  .wrap-box {
    padding: 10px;
    box-sizing: border-box;
    // height: 100%;
    width: 100%;
    .carForm {
      display: flex;
      .form-item {
        width: 300px;
        .form-input {
          width: 200px !important;
        }
      }
      .form-buttom {
        height: 33px;
      }
    }
    .cldCarForm {
      .form-item {
        width: 300px;
        .form-input {
          width: 200px;
        }
      }
      .form-buttom {
        height: 33px;
      }
    }
  }
}
.pageNew {
  text-align: right;
  padding: 14px 0px 0px 0px;
}
.nc ::v-deep .el-input {
  width: 197px !important;
}
.ztWrap {
  overflow: hidden;
  white-space: normal;
}
.flexbox {
  display: flex;
  padding-left: 20px;
  margin-top: 15px;
}
.flexbox div {
  margin-right: 10px;

}
.flexbox div span{
  width: 70px;
  display: inline-block;
  text-align: left;
  font-weight: 600;
}
// .flexbox :first-child{
//   color: antiquewhite;
// }
.seach-box {
  display: flex;
  align-items: center;
  text-align: left;
  .time {
    margin-right: 10px;
  }
  .select {
    margin-right: 10px;
  }
}
.dialogbox {
  text-align: left;
}
.sonbox {
  padding-left: 20px;
  margin-top: 10px;
}
.box {
  margin-bottom: 10px;
}
.sonbox-box {
  margin-top: 10px;
}
</style>
